import React from 'react';
import { Card, Props } from '../../Atoms/Card';
import { CardHeader } from '../../Atoms/CardHeader';

/**
 * We have several screens where a Card is used for the main body of a page
 * This component merely standardizes the padding and header of these cards
 */
export interface BodyCardProps extends Props {
  header?: React.ReactNode;
}

export const BodyCard: React.FC<BodyCardProps> = (
  props: BodyCardProps
): JSX.Element => {
  const { header, children, ...cardProps } = props;
  return (
    <Card px={6} py={4} {...cardProps}>
      {header && <CardHeader>{header}</CardHeader>}
      {children}
    </Card>
  );
};
